import { getCookie } from "../common/utils";
import { USER_CURRENCY_COOKIE, DEFAULT_SELECTED_CURRENCY } from "../common/constants";
import { PosCurrency } from "./index";

export async function getDefaultSelectedCurrencyAndContinent() {
  try {
    const currencyInCookie = getCookie(USER_CURRENCY_COOKIE);
    if (currencyInCookie && !Object.keys(DEFAULT_SELECTED_CURRENCY).includes(currencyInCookie)) {
      const posCurrency = PosCurrency.getInstance();
      const { continent, currencySymbol, currencyLabel, currencyCode: currency } = await posCurrency.getContinentFromCurrency(
        currencyInCookie
      );
      return  {
        continent,
        currency,
        currencySymbol,
        currencyLabel
      }
    }
    return (currencyInCookie && currencyInCookie === 'USD') ? DEFAULT_SELECTED_CURRENCY['USD'] : DEFAULT_SELECTED_CURRENCY['EUR'];
  } catch (error) {
    return DEFAULT_SELECTED_CURRENCY['EUR'];
  }
}